import { getField, updateField } from 'vuex-map-fields';
import { UsersPermissions } from "@/api/users_permissions";


class TableList { 
    constructor({ url, footerItemsPerPageText}) { 
        this.headers = [];
        this.searchFilters = ['companydb'],
        this.itemsPermissions = [];
        this.selectedCompanyies = [];
        this.selectedUsers = [];
        this.url = url;
        this.footerItemsPerPageText = footerItemsPerPageText;
        this.loading = false;
        this.hasPermissions = false;
    }
}

class CheckboxData {
    constructor({ label }) {
        this.label = label;
        this.selected = false;
    }
}

class ModalData {
    constructor() {
        this.items = [];
        this.selected = '';
        this.show = false;
        this.loading = false;
    }
}

const models = {
    TableList,
    ModalData,
    CheckboxData
};


let permissionsTable = new TableList({url: 'get_users_permissions_table/items/', footerItemsPerPageText: 'Empresas por página'});
let modalPermission = new ModalData();
let allCompanyiesCheckbox = new CheckboxData({ label: 'Todas las empresas' })
let allUsersCheckbox = new CheckboxData({label: 'Todos los usuarios'})

const state = () => ({
    permissions: permissionsTable,
    modalPermission: modalPermission,
    allCompanyiesCheckbox: allCompanyiesCheckbox,
    allUsersCheckbox: allUsersCheckbox,
});


const getters = {
    permissions: state => state.permissions,
    headers: state => state.headers.slice(),
    modalPermission: state => state.modalPermission,
    allCompanyiesCheckbox: state => state.allUsersCheckbox,
    allUsersCheckbox: state => state.allUsersCheckbox,
    selectedCompanyiesIds: (state) => {
        let companyiesIds = [];
        for (var i = 0; i < state.permissions.selectedCompanyies.length; i++) {
            companyiesIds.push(state.permissions.selectedCompanyies[i].id);
        }
        return companyiesIds;
    },
    selectedUsersIds: (state) => {
        let usersIds = [];
        for (var i = 0; i < state.permissions.headers.length; i++) {
            if (state.permissions.headers[i].selected && state.permissions.headers[i].checkbox) {
                usersIds.push(state.permissions.headers[i].value);
            }
        }
        return usersIds;
    },
    getField
};


const SET_PERMISSIONS_LOADING = 'SET_PERMISSIONS_LOADING';
const SET_PERMISSIONS_HEADERS = 'SET_PERMISSIONS_HEADERS';
const SET_PERMISSIONS_HEADER = 'SET_PERMISSIONS_HEADER';
const SET_PERMISSIONS_ITEMS_PERMISSIONS = 'SET_PERMISSIONS_ITEMS_PERMISSIONS';
const SET_PERMISSIONS_HAS_PERMISSION = 'SET_PERMISSIONS_HAS_PERMISSION';
const SET_MODAL_ITEMS = 'SET_MODAL_ITEMS';
const SET_MODAL_SHOW = 'SET_MODAL_SHOW';
const SET_MODAL_LOADING = 'SET_MODAL_LOADING';
const SET_ALL_USERS = 'SET_ALL_USERS';
const SET_SELECTED_USERS = 'SET_SELECTED_USERS';
const SET_ALL_COMPANYIES = 'SET_ALL_COMPANYIES';
const SET_SELECTED_COMPANYIES = 'SET_SELECTED_COMPANYIES';
const SET_MODAL_SELECTED = 'SET_MODAL_SELECTED';
const SELECTED_ALL_HEADERS = 'SELECTED_ALL_HEADERS';

const mutations = {
    [SET_PERMISSIONS_LOADING](state, loading) {
        state.permissions.loading = loading;
    },
    [SET_PERMISSIONS_HEADERS](state, headers) {
        state.permissions.headers = headers;
    },
    [SET_PERMISSIONS_HEADER](state, { header, value }) {
        header.selected = value;
    },
    [SET_PERMISSIONS_ITEMS_PERMISSIONS](state, itemsPermissions) {
        state.permissions.itemsPermissions = itemsPermissions;
    },
    [SET_PERMISSIONS_HAS_PERMISSION](state, hasPermissions) {
        state.permissions.hasPermissions = hasPermissions;
    },
    [SET_MODAL_ITEMS](state, items) {
        state.modalPermission.items = items;
    },
    [SET_MODAL_LOADING](state, loading) {
        state.modalPermission.loading = loading;
    },
    [SET_MODAL_SELECTED](state, selected) {
        state.modalPermission.selected = selected;
    },
    [SET_MODAL_SHOW](state, show) {
        state.modalPermission.show = show;
    },
    [SET_ALL_USERS](state, selected) {
        state.allUsersCheckbox.selected = selected;
    },
    [SET_ALL_COMPANYIES](state, selected) {
        state.allCompanyiesCheckbox.selected = selected;
    },
    [SET_SELECTED_COMPANYIES](state, items) {
        state.permissions.selectedCompanyies = items;
    },
    [SET_SELECTED_USERS](state, items) {
        state.permissions.selectedUsers = items;
    },
    [SELECTED_ALL_HEADERS](state) {
        for (var i = 0; i < state.permissions.headers.length; i++) {
            if (state.permissions.headers[i].checkbox) {
                state.permissions.headers[i].selected = state.allUsersCheckbox.selected;
            }
        }
    },
    updateField
};


const initPermissionsTable = ({ commit, state }) => {
    return new Promise((resolve, reject) => { 
        commit(SET_PERMISSIONS_LOADING, true);
        UsersPermissions.getUsersPermissionsExtraTableData().then(response => {
            commit(SET_PERMISSIONS_HEADERS, response.data['headers']);
            commit(SET_PERMISSIONS_ITEMS_PERMISSIONS, response.data['items_permission']);
            commit(SET_MODAL_ITEMS, response.data['friendship_kinds'])
            checkPermissions({commit, state});
            commit(SET_PERMISSIONS_LOADING, false);
            resolve()
        }).catch(error => {
            commit(SET_PERMISSIONS_LOADING, false);
            reject();
        });
    })
}

const setPermissionsLoading = ({ commit }, loading) => {
    commit(SET_PERMISSIONS_LOADING, loading);
}

const checkPermissions = ({ commit, state }) => {
    let hasPermissions = state.permissions.itemsPermissions.length > 1;
    commit(SET_PERMISSIONS_HAS_PERMISSION, hasPermissions);
}

const selectCheckboxAllUsers = ({ commit, state }, ref) => {
    commit(SELECTED_ALL_HEADERS);
}

const selectedUserPermission = ({ commit, state }, item) => {
    commit(SET_PERMISSIONS_HEADER, { header: item, value: !item.selected });
}

const selectCheckboxAllCompanies = ({ commit, state }, ref) => {
    ref.selectedItems = [];
    if (state.allCompanyiesCheckbox.selected) {
        for (var i = 0; i < ref.items.length; i++) {
            ref.selectedItems.push(ref.items[i])
        }
    }
    commit(SET_SELECTED_COMPANYIES, ref.selectedItems);
}

const selectedCompanyPermission = ({ commit, state }, { items, ref }) => {
    let check = ref.items.length == items.length;
    commit(SET_ALL_COMPANYIES, check);
    commit(SET_SELECTED_COMPANYIES, items);
}


const openPermissionDialog = ({ commit, state, dispatch }) => {
    commit(SET_MODAL_SELECTED, '');
    commit(SET_MODAL_SHOW, true);
} 

const resetPermissionsTable = ({ commit, state, dispatch }, ref) => {
    commit(SET_ALL_COMPANYIES, false);
    commit(SET_ALL_USERS, false);
    dispatch("selectCheckboxAllCompanies", ref);
    dispatch("selectCheckboxAllUsers", ref);
}

const closePermissionDialog = ({ commit, state, dispatch}, ref) => {
    dispatch("resetPermissionsTable", ref);
    commit(SET_MODAL_SHOW, false);
}

const setModalLoading = ({ commit, state }, loading) => {
    commit(SET_MODAL_LOADING, loading)
}

const actions = {
    initPermissionsTable,
    setPermissionsLoading,
    checkPermissions,
    selectCheckboxAllUsers,
    selectCheckboxAllCompanies,
    selectedCompanyPermission,
    selectedUserPermission,
    closePermissionDialog,
    openPermissionDialog,
    setModalLoading,
    resetPermissionsTable,
};


export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
    models
}